import React from "react";
import { Sheet, SheetTrigger, SheetContent } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Link } from "gatsby";
import Logo from "../../images/e-health_logo.png";
import ListComponent from "../utils/ListComponent";
import { NavigationItems } from "../utils/NavigationItems";
import { useSelector } from "react-redux";
import { RootState } from "@/state/store";
import UserDropdown from "../navigation/UserDropdown";
import { useAuth } from "react-oidc-context";

export default function Navbar() {
  const userStore = useSelector((state: RootState) => state.user);
  const auth = useAuth()

  return (
    <header className="flex h-20 w-full shrink-0 items-center px-4 md:px-6 lg:px-20">
      <Sheet>
        <SheetTrigger asChild>
          <Button variant="outline" size="icon" className="lg:hidden">
            <MenuIcon className="h-6 w-6" />
            <span className="sr-only">Toggle navigation menu</span>
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="bg-white">
          <Link to="#" className="mr-6 hidden lg:flex">
            <CompanyLogo />
            <span className="sr-only">E-health</span>
          </Link>
          <div className="grid gap-2 py-6">
            <ListComponent
              data={NavigationItems}
              renderItem={(item, i) => (
                <Link
                  key={i}
                  to={item.link}
                  className="flex w-full items-center py-2 text-lg font-semibold"
                  activeClassName="font-semibold border-b-accentRed border-b-2"
                >
                  {item.name}
                </Link>
              )}
            />
          </div>
        </SheetContent>
      </Sheet>
      <Link to="#" className="mr-6 hidden lg:flex">
        <CompanyLogo />
        <span className="sr-only">E-health</span>
      </Link>
      <nav className="ml-auto hidden lg:flex gap-10">
        <ListComponent
          data={NavigationItems}
          renderItem={(item, i) => (
            <Link
              key={i}
              to={item.link}
              className={`flex py-2 text-lg`}
              activeClassName="font-semibold border-b-accentRed border-b-2"
            >
              {item.name}
            </Link>
          )}
        />
        {auth.isAuthenticated && userStore.user ? (
          <Link to="" className={`flex py-2 text-lg`}>
            <UserDropdown userName={userStore.user.firstName} />
          </Link>
        ) : (
          ""
        )}
      </nav>
    </header>
  );
}

function MenuIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="4" x2="20" y1="12" y2="12" />
      <line x1="4" x2="20" y1="6" y2="6" />
      <line x1="4" x2="20" y1="18" y2="18" />
    </svg>
  );
}

function CompanyLogo() {
  return <img src={Logo} alt="E-health logo" />;
}
